// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__go0QL","hide":"Sidebar_hide__Dzpmt","toggle":"Sidebar_toggle__GHp2o","nav":"Sidebar_nav__tYWn7"};